module.exports = __webpack_public_path__ + "img/kr-product-ecmy-card2-img4.7b9b31d.png";